import { toast } from 'react-toastify'

import styles from './styles.module.scss'

import { Loader } from '@/components/Loader'

import { courseStore } from '@/stores/course.store'
import { Course } from '@/domain/entities/course.entity'
import { CoursesService } from '@/services/courses/course.service'
import { useDeleteCourse } from '@/pages/@hooks/use-delete-course'
import { useUpdateCourse } from '@/pages/@hooks/use-update-course'

interface IProps {
  initEditarCurso: (course: Course) => void
}

const courseService = new CoursesService()

export const SeeCourses = ({ initEditarCurso }: IProps) => {
  const { setCourses, courses } = courseStore()

  const { deleteCourse, isPendingDelete } = useDeleteCourse({ courseService })
  const { isPending, updateCourse } = useUpdateCourse({ courseService })

  async function desativarCurso(course: Course) {
    const [curso] = await updateCourse({
      ...course,
      status: course.status === 'ATIVO' ? 'BLOQUEADO' : 'ATIVO',
      active: course.status === 'ATIVO' ? true : false,
    })
    const coursesFiltered = courses.filter((c) => c.id !== course.id)
    setCourses([...coursesFiltered, curso])
  }

  async function deletarCurso(course_id: string) {
    try {
      await deleteCourse(course_id)
      const coursesFiltered = courses.filter((curso) => curso.id !== +course_id)
      setCourses(coursesFiltered)
    } catch (error) {
      toast.error('Erro ao deletar curso. Tente novamente mais tarde.')
    }
  }

  return (
    <div>
      {(isPendingDelete || isPending) && <Loader />}

      {courses?.length > 0 &&
        courses.map((curso) => {
          if (!curso) return
          return (
            <div key={curso.id} className={styles.curso}>
              <p>{curso.name}</p>
              <p>||</p>
              <a href="#" onClick={() => desativarCurso(curso)}>
                {curso.status}
              </a>
              <p>||</p>
              <div className={styles.content_button}>
                <button onClick={() => deletarCurso(curso.id.toString())}>
                  DELETAR
                </button>
                <button onClick={() => initEditarCurso(curso)}>EDITAR</button>
              </div>
            </div>
          )
        })}

      {courses?.length === 0 && <div>Essa instituição nao possui cursos</div>}
    </div>
  )
}
